import { render, staticRenderFns } from "./OeSentenceTemp.vue?vue&type=template&id=784a8c00&scoped=true&"
import script from "./OeSentenceTemp.vue?vue&type=script&lang=js&"
export * from "./OeSentenceTemp.vue?vue&type=script&lang=js&"
import style0 from "./OeSentenceTemp.vue?vue&type=style&index=0&id=784a8c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a8c00",
  null
  
)

export default component.exports